import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export const ExportToExcel = ({ apiData, fileName, buttonText = 'Export' }) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const [loading, setLoading] = React.useState(false);

  const exportToCSV = (apiData, fileName) => {
    setLoading(true);
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
    setLoading(false);
  };

  return (
    <div>
      <button
        className='btn btn-info ml-2'
        onClick={(e) => exportToCSV(apiData, fileName)}
      >
        {buttonText}
        {loading && (
          <span id='exportExcel' className='ml-3 spinner spinner-white '></span>
        )}
      </button>
    </div>
  );
};
